<template>
    <v-container fluid ma-3 pa-3>
        <v-layout row wrap justify-center>
            <v-flex>
                <span class="style_title">Startup Management</span>
                <br>
                <br>
                <div>
                    <span class="style_description" style="white-space: pre-line">In the "Startup Management" panel the admin can manage the list of startups registered in Discovery.
On the " Approved" tab there is a list of startups that have applied for registration and have already been approved, or have been added to the list directly by an admin.
On the "To be confirmed" tab there is a list of startups that have applied for registration from the public portal and are waiting for approval.
                        <br>
                        <v-img
                                max-width="400"
                                :src="require('@/assets/img/help/tabStartup.png')"
                        >
                </v-img>
</span>
                    <br>
                    <br>
                    <span class="style_paragraph" style="white-space: pre-line">Register a new startup from scratch</span><br>
                    <span class="style_description" style="white-space: pre-line">In order to add a new startup to the list, the admin can click on the green button "Add new".
The admin has to fill in the fields with the data of the startup available, following the rules better explained in the appropriate paragraph.
Once you have filled in the fields just click on the green "Save" button, otherwise press the red "Clear" button to clean and reset all the fields.
The proposal for the insertion of a new startup is not immediate: it must first be validated by an approver. The admin who submitted the proposal will be notified by email about the outcome of the evaluation. In case of rejection of the proposal, the text of the email will include a short justification.
</span>
                    <br>
                    <br>
                    <span class="style_paragraph" style="white-space: pre-line">Validate and accept or deny a registration proposal</span><br>
                    <span class="style_description" style="white-space: pre-line">On the "To be confirmed" tab there is a list of startups that have applied for registration from the public portal and are waiting for approval.
An admin can:
    <ul>
        <li>reject the registration proposal from the panel with the complete list, by clicking on the red icon to the right of the startup name</li>
        <br>
                        <v-img
                                max-width="600"
                                :src="require('@/assets/img/help/discard.png')"
                        >
                </v-img>
        <br>
        <li>click on the startup name to read the startup details and:
        <ul>
            <li>approve the insertion of the startup, filling in the empty fields if necessary, by pressing the green "Approve" button</li>
            <li>reject the startup by pressing the red "Discard" button.</li>
        </ul>
        </li>
    </ul>

In any case, any operation must be approved by Discovery's "approvers". The admin who submitted the proposal will be notified by email about the outcome of the evaluation. In case of rejection of the proposal, the text of the email will include a short justification.

The startup will receive the result of the evaluation of its registration by email. If the it is positive, the email will contain the identification token.
</span>
                    <br>
                    <br>
                    <span class="style_paragraph" style="white-space: pre-line">Modify startup-related data</span><br>
                    <span class="style_description" style="white-space: pre-line">In order to modify the data related to a registered startup from the list, the admin can click on the startup name.
The admin can modify the fields, following the rules better explained in the next paragraph.
Once you have filled in the fields just click on the green "Save" button, otherwise press the red "Clear" button to clean and reset all the fields.
The proposal for the update of a startup is not immediate: it must first be validated by an approver. The admin who submitted the proposal will be notified by email about the outcome of the evaluation. In case of rejection of the proposal, the text of the email will include a short justification.
</span>
                    <br>
                    <br>
                    <span class="style_paragraph" style="white-space: pre-line">Rules for filling startup-related data</span><br>
                    <span class="style_description" style="white-space: pre-line">Here are the details and rules to follow when filling in the fields:
<ul>
    <li>Startup Name: name/company name identifying the startup. Maximum 50 characters</li>
    <li>Country: choose from the drop-down menu</li>
    <li>Region/city: if the country is Italy you can choose the region from the drop-down menu, otherwise write the city (maximum 100 characters, special characters are not allowed)</li>
    <li>Area: choose your technology area from the drop-down menu</li>
    <li>Vertical solution: to be selected after choosing the area. Choose a vertical from those available in the drop-down menu.</li>
    <li>Idea state: choose a value from the drop-down menu</li>
    <li>Contact name: name of the reference person(s) to contact. Maximum 100 characters. Special characters are not allowed.</li>
    <li>Email addresses: one or more email contacts. In the case of multiple contacts, you must separate each of them with the symbols , or ; or /. Maximum 500 characters</li>
    <li>Patents available: choose value from drop-down menu</li>
    <li>SDK/API available: choose value from drop-down menu</li>
    <li>Business model: choose value from drop-down menu</li>
    <li>Website: URL with the website. Maximum 500 characters</li>
    <li>Tags: choose one or more tags from the drop down menu, or write your own (separate each tag by pressing Enter)</li>
    <li>Mobile phone: only numbers, punctuation and + for prefixes allowed. Maximum 100 characters</li>
    <li>Contact links: URL of the profile of the person to be contacted (e.g. Linkedin profile). Maximum 500 characters</li>
    <li>Contact address: Maximum 200 characters. Special characters not allowed</li>
    <li>Logo: URL with the logo image. Maximum 500 characters</li>
    <li>Crunchbase link: URL of Crunchbase profile. Maximum 500 characters</li>
    <li>Fundings amount: Maximum 200 characters. Special characters not allowed</li>
    <li>Fundings investors: Maximum 200 characters. Special characters not allowed</li>
    <li>Foundation: date or year of foundation. Maximum 100 characters. Special characters not allowed</li>
    <li>Number Employees: numeric positive field. Special characters not allowed</li>
    <li>Url Video: URL with the video. Maximum 500 characters</li>
    <li>English idea description: english textual description. Maximum 3000 characters</li>
    <li>Italian idea description: italian textual description. Maximum 3000 characters</li>
    <li>State of contact: choose value from drop-down menu</li>
    <li>Addressed Market: choose value from drop-down menu</li>
    <li>Technology area: choose value from drop-down menu</li>
    <li>Replication complexity: choose value from drop-down menu</li>
    <li>Deployment Complexity: choose value from drop-down menu</li>
    <li>Technological Footprint: choose value from drop-down menu</li>
    <li>Extensive Business Enabler: choose value from drop-down menu</li>
    <li>Funding Status: choose value from drop-down menu</li>
    <li>Financial Status: choose value from drop-down menu</li>
    <li>NTT DATA SPOC: NTT DATA contact person. Maximum 200 characters. Special characters not allowed</li>
    <li>Opportunities: Maximum 1000 characters</li>
    <li>Project State (if any): Maximum 1000 characters</li>
    <li>Battlecard available: choose value from drop-down menu</li>
    <li>Agreement: choose value from drop-down menu</li>
    <li>Evaluation date (month): choose from the calendar the month in which the startup was evaluated</li>
    <li>Link to folder in Peers: URL of Peers repository with startup material</li>
    <li>OpCo: choose value from drop-down menu</li>
    <li>Substainability Goals: choose one or more goals from the drop down menu</li>
    <li>Token: identification token automatically generated (read only field)</li>
    <li>Score: field automatically calculated according to the values of selected fields. For more details on score calculation, click on the question mark icon</li>
    </ul>
</span>
                </div>
                <br>


            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    export default {
        name: "StartupManagementHelp",
        components: {},
        data() {
            return {

            }
        },

        methods: {

        }
    }
</script>

<style scoped>
    .style_description{
        font-size: 18px;
    }

    .style_paragraph{
        font-size: 22px;
        font-weight: bold;
    }

    .style_title{
        font-size: 34px;
        font-weight: bold;
    }

</style>